import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is a Lean Startup plan, and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>A lean startup plan is a business strategy that involves developing and testing a product or service with a minimum viable product (MVP) in order to gather feedback quickly and make necessary adjustments. The goal of a lean startup plan is to minimize waste and risk while maximizing learning and progress. This approach can be handy for businesses looking to bring new products or services to market quickly and efficiently.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the critical components of a lean startup plan?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The critical components of a lean startup plan typically include MVP, customer development, and agile development. The MVP is a minimal product or service designed to test key assumptions and gather feedback from potential customers. Customer development involves actively seeking out and engaging with potential customers to validate the product or service and gather feedback. Agile development is a process that involves frequent iteration and adaptation based on feedback from customers and the market.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How can TekRevol help me develop a lean startup plan for my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol has a team of experienced professionals with expertise in lean startup planning and execution. We have a track record of success in helping businesses to develop and test MVPs, engage with potential customers, and implement agile development processes. Whether you're looking to bring a new product or service to market or to optimize your existing business model, we can help you create a custom lean startup plan that meets your specific needs and goals.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;